import { Component, OnInit, Input } from '@angular/core';
import { PessoaService } from 'app/shared/pessoa/pessoa.service';
import { ModalService } from 'app/shared/modal/modal.service';
import { ModalRecuperarSenhaService } from '../../shared/modal-recuperar-senha/modal-recuperar-senha.service';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';


@Component({
  selector: 'modal-recuperar-senha',
  templateUrl: './modal-recuperar-senha.component.html',
  styleUrls: ['./modal-recuperar-senha.component.scss'],
  providers: [ModalRecuperarSenhaService],
})
export class ModalRecuperarSenhaComponent implements OnInit {

  @Input() id: string;

  public cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  public cpf;
  public email = '';
  public recuperacaoLoading;
  public environment = environment;
  public senhaRecuperada;
  public url;

  constructor(
    private pessoaService: PessoaService,
    private modalService: ModalService,
    private modalRecuperarSenhaService: ModalRecuperarSenhaService,
    private router: Router
  ) { }

  ngOnInit() {
    this.url = this.router.url;
    //console.log(this.url);
    this.id = this.id && this.id.length > 0 ? this.id : 'modal-recuperar-senha';
    this.recuperacaoLoading = false;
  }

  enviar(idModal) {
    let tipoRecSenha = idModal.split("-")[3].toUpperCase(); //CONTRATANTE
    let contexto = this.environment.loginContexto;
    let siglaSistema;
    switch(tipoRecSenha){
      case 'CONTRATANTE':
        siglaSistema = 'CONT'
        break;
      case 'GLOBAL': default:
        siglaSistema = 'VEST'
        break;
    }
    //CONTEXTO
    this.recuperacaoLoading = true;
    this.modalRecuperarSenhaService.iniciarRecuperacaoDeSenha(this.cpf.replace(/\D+/g, ''), this.email, contexto, tipoRecSenha, siglaSistema).subscribe(
      data => {
        this.senhaRecuperada = data.mensagem;
        this.recuperacaoLoading = false;
        this.modalService.close(this.id);
        this.modalService.open(`modal-nova-senha-enviada-${siglaSistema.toLowerCase()}`);
      },
      error => {
        console.log(error);
        this.recuperacaoLoading = false;
        this.modalService.close(this.id);
        this.modalService.open(`modal-usuario-nao-encontrado-${siglaSistema.toLowerCase()}`);
      },
    );
  }

  isCpfValido() {
    if (this.cpf) {
      return this.pessoaService.validarCpf(this.cpf);
    }
    return null;
  }

  isCpdValido(){
    //console.log(this.email.match(/^[0-9]{1,7}$/));
    if(!this.email.match(/^[0-9]{1,7}$/) || this.email.length<=0){
      return false;
    }
    return true;
  }

  isEmailValido() {
    if (/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(this.email)) {
      return true;
    }
    return false;
  }

  liberarEnvio() {
    return this.isCpfValido() && (this.isEmailValido() || this.isCpdValido()) && !this.recuperacaoLoading;
  }

  reset() {
    this.cpf = null;
    this.email = '';
    this.recuperacaoLoading = false;
  }
}
